export default __webpack_public_path__ + "static/media/SphereCoreSpirit.bd341079.webp";